import React, { useEffect, useState } from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft, Lock, Shield, CheckCircle, Loader } from 'lucide-react';
import StripePaymentForm from './StripePaymentForm';

const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
const stripePromise = stripePublishableKey ? loadStripe(stripePublishableKey) : null;

const StripePaymentPage = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const [options, setOptions] = useState(null);
    const { clientSecret, planName, planPrice } = location.state || {};

    console.log(planName, planPrice)

    useEffect(() => {
        if (clientSecret) {
            setOptions({
                clientSecret,
                appearance: {
                    theme: 'stripe',
                    variables: {
                        colorPrimary: '#2563eb',
                        colorBackground: '#ffffff',
                        colorText: '#1f2937',
                        colorDanger: '#dc2626',
                        fontFamily: 'Inter, system-ui, sans-serif',
                        spacingUnit: '4px',
                        borderRadius: '8px',
                    },
                    rules: {
                        '.Input': {
                            border: '1px solid #d1d5db',
                            padding: '12px 16px',
                            fontSize: '16px',
                            transition: 'all 0.2s ease-in-out',
                        },
                        '.Input:focus': {
                            borderColor: '#2563eb',
                            boxShadow: '0 0 0 3px rgba(37, 99, 235, 0.1)',
                        },
                        '.Label': {
                            fontWeight: '600',
                            color: '#374151',
                            marginBottom: '8px',
                        },
                        '.Tab': {
                            border: '1px solid #e5e7eb',
                            padding: '12px 16px',
                        },
                        '.Tab--selected': {
                            borderColor: '#2563eb',
                            backgroundColor: '#f8fafc',
                        }
                    },
                },
                // mode: 'payment',
                // paymentMethodCreation: {
                //     paymentMethodTypes: ['card'],
                // }
            })
        }
    }, [clientSecret])

    const handleBack = () => {
        navigate(-1);
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md mx-auto">
                {/* Header */}
                <div className="text-center mb-8">
                    <button
                        onClick={handleBack}
                        className="flex items-center text-gray-600 hover:text-gray-800 transition-colors mb-6 mx-auto"
                    >
                        <ArrowLeft className="w-5 h-5 mr-2" />
                        Back to plans
                    </button>

                    <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                        <Lock className="w-8 h-8 text-green-600" />
                    </div>
                    <h1 className="text-3xl font-bold text-gray-900 mb-2">
                        Complete Payment
                    </h1>
                    <p className="text-gray-600">
                        Secure checkout powered by Stripe
                    </p>
                </div>

                {/* Order Summary */}
                {planName && planPrice && (
                    <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 mb-6">
                        <h3 className="font-semibold text-gray-900 mb-4">Order Summary</h3>
                        <div className="flex justify-between items-center mb-2">
                            <span className="text-gray-600">{planName}</span>
                            <span className="font-semibold text-gray-900">Ksh{planPrice}/month</span>
                        </div>
                        <div className="flex justify-between items-center pt-4 border-t border-gray-100">
                            <span className="font-semibold text-gray-900">Total</span>
                            <span className="text-xl font-bold text-gray-900">Ksh{planPrice}</span>
                        </div>
                    </div>
                )}

                <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
                    {!stripePromise ? (
                        <div className="text-center py-12">
                            <Shield className="w-8 h-8 text-red-500 mx-auto mb-4" />
                            <p className="text-red-600 font-semibold mb-2">Payment System Unavailable</p>
                            <p className="text-gray-500 text-sm">Stripe publishable key is missing from the environment configuration.</p>
                        </div>
                    ) : options ? (
                        <Elements stripe={stripePromise} options={options}>
                            <StripePaymentForm planName={planName} />
                        </Elements>
                    ) : (
                        <div className="text-center py-12">
                            <Loader className="w-8 h-8 text-blue-600 animate-spin mx-auto mb-4" />
                            <p className="text-gray-600">Loading payment details...</p>
                        </div>
                    )}
                </div>

                {/* Security Features */}
                <div className="mt-6 text-center">
                    <div className="flex items-center justify-center space-x-6 text-sm text-gray-500">
                        <div className="flex items-center space-x-2">
                            <Shield className="w-4 h-4" />
                            <span>PCI Compliant</span>
                        </div>
                        <div className="flex items-center space-x-2">
                            <Lock className="w-4 h-4" />
                            <span>256-bit SSL</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StripePaymentPage;